import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-administrador-catalogo',
  templateUrl: './administrador-catalogo.component.html',
  styleUrls: ['./administrador-catalogo.component.scss'],
  providers: [MessageService]
})
export class AdministradorCatalogoComponent {
  catalogoForm: FormGroup;
 
  constructor(
    private fb: FormBuilder,
    private messageService: MessageService
  ) {    
    this.catalogoForm = this.crearFormulario();
  }


  onSubmit() {
    if (this.catalogoForm.valid) {
      console.log('Formulario enviado:', this.catalogoForm.value);
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: 'Catalogo registrado correctamente'
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      this.markFormGroupTouched(this.catalogoForm);
    }
  }
  crearFormulario(): FormGroup {
    return this.fb.group({    
      descripcion: ['', [Validators.required, Validators.minLength(3)]],
    });
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
    });
  }

  get f() {
    return this.catalogoForm.controls;
  }
}
